export default __webpack_public_path__ + "static/media/wrong.70f950f8.svg";